export default __webpack_public_path__ + "static/media/8aa4abaa81beec448be6a0f387511bdd.svg";